import { Icon, ScannerModal } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { FilterFieldType } from '../../shared/fields'
import { FilterOperator } from '../../types'
import Operators from '../Operators/Operators'
import DataField from './DataField'
import type { FieldReadyModel } from './hooks/useField'
import { ActionSlotButton, StyledField, StyledFieldContainer } from './styles'

const FieldView = (props: FieldReadyModel) => {
  const { t } = useTranslation()

  const { refs, handlers, qr, field } = props

  const {
    isOpen: isQrCodeReaderOpen,
    close: closeQrCodeReader,
    open: openQrCodeReader,
    enableQRCodeReader
  } = qr

  const { onChangeOperator, onResolveFilterQuery, onScanSuccess } = handlers

  const { fieldLayout, uuid, fieldData, currentOperator } = field

  const { inputRef, parentRef } = refs

  const operatorsType =
    fieldData.type === FilterFieldType.Relation ? 'array' : 'string'

  return (
    <>
      <ScannerModal
        isOpen={isQrCodeReaderOpen}
        onClose={closeQrCodeReader}
        onScanSuccess={onScanSuccess}
      />
      <StyledFieldContainer fieldLayout={fieldLayout} key={uuid}>
        <StyledField>
          <DataField inputRef={inputRef} parentRef={parentRef} />
          <Operators
            currentOperator={currentOperator}
            type={operatorsType}
            handleChange={onChangeOperator}
          />
        </StyledField>
        {enableQRCodeReader && (
          <ActionSlotButton
            onClick={openQrCodeReader}
            variant='secondary'
            aria-label={t('qr-code-reader.read-qr-code')}
          >
            <Icon iconName='QRCodeReader' icSize='semiSmall' />
          </ActionSlotButton>
        )}
        {currentOperator === FilterOperator.Filteraction && (
          <ActionSlotButton
            onClick={onResolveFilterQuery}
            variant='secondary'
            aria-label={t('filter-fields.resolve-filter-action')}
          >
            R
          </ActionSlotButton>
        )}
      </StyledFieldContainer>
    </>
  )
}

export default FieldView
